(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Read More toggle
    document.querySelectorAll('[data-fur-more]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const body = btn.previousElementSibling;
        const isClamped = body.classList.toggle('is-clamped');
        btn.setAttribute('aria-expanded', !isClamped);
        btn.textContent = isClamped ? btn.dataset.more : btn.dataset.less;
      });
    });

    // Native smooth scroll carousel navigation
    document.querySelectorAll('.fur-rv').forEach((section) => {
      const track = section.querySelector('[data-fur-track]');
      const prev = section.querySelector('[data-fur-prev]');
      const next = section.querySelector('[data-fur-next]');

      if (!track || !prev || !next) return;

      const getScrollDistance = () => track.clientWidth * 0.8;

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
